export var PlaceholderText = /*#__PURE__*/function (PlaceholderText) {
  PlaceholderText["imgPreview"] = "\u043F\u043E\u0434\u043F\u0438\u0441\u044C";
  PlaceholderText["textMessage"] = "\u043D\u0430\u043F\u0438\u0448\u0438\u0442\u0435, \u0447\u0435\u043C \u0432\u0430\u043C \u043F\u043E\u043C\u043E\u0447\u044C";
  return PlaceholderText;
}({});
export var POINT_TEXTAREA_HEIGHT_LIST = [72, 80, 92, 100, 112, 120, 132, 140, 152, 160];